import { IQuery, useFirebaseData } from "../../@shared/hooks/useFirebaseData";
import { Collections } from "../../@core/constants/FirebasePaths";
import { IPost } from "../../@core/interfaces/IPost";
import { useUserSessionStore } from "../../stores/UserSession.store";
import { IUser } from "../../@core/interfaces/IUser";
import { Queries } from "../../@core/constants/Queries";

export const useBlog = ({ loadData = false, queries = [] }: { loadData: boolean, queries?: IQuery[] }) => {
  const user = useUserSessionStore((state) => state.user);
  const db = useFirebaseData<IPost>({
    collectionPath: Collections.blog._path,
    loadData,
    queries : [...queries, ...Queries.trash],
    initialPopulate: {
      fields: ["company"]
    }
  });

  const createPost = async (post: IPost) => {
    try {
      const imageUrl: any = post.coverURL;
      delete post.coverURL;
      const newPost = await db.add({
        ...post,
        coverURL: '',
        company: db.getReference(`${Collections.users._path}/${user.id}`)
      });

      if (imageUrl instanceof FileList && imageUrl.length > 0) {
        const coverURL = await db.uploadFile(imageUrl[0], `${Collections.blog._path}/${newPost.id}`);
        await db.update(newPost.id, { coverURL });
      }
    } catch (e) {
      console.log(e);
    }
  };

  const updatePost = async (postId: string, post: Partial<IPost>) => {
    try {
      let coverURL: any = post.coverURL;
      delete post.coverURL;

      if (coverURL instanceof FileList && coverURL.length > 0) {
        coverURL = await db.uploadFile(coverURL[0], `${Collections.blog._path}/${postId}`);
      }

      await db.update(postId, { ...post, coverURL });
    } catch (e) {
      console.log(e);
    }
  };

  const deletePost = async (postId: string) => {
    return await db.trash(postId);
  };

  const getPost = async (postId: string): Promise<IPost> => {
    const post = await db.docWithId(`${Collections.blog._path}/${postId}`) as IPost;
    if (!post) return null;
    const company = await db.docWithId(post.company.path) as IUser;
    return { ...post, company }
  };

  return {
    posts: db.data,
    createPost,
    deletePost,
    updatePost,
    getPost
  };
};
